import React from "react";

export const ReloadIconDark = (props) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="28"
        height="25"
        viewBox="0 0 28 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.52917 12.1548H3.7678L3.7789 11.9164C4.08095 5.42863 9.33134 0.25 15.75 0.25C22.3622 0.25 27.75 5.74043 27.75 12.5C27.75 19.2596 22.3622 24.75 15.75 24.75C12.6696 24.75 9.86375 23.5501 7.73585 21.5923L10.2586 18.1812C11.6717 19.6024 13.6094 20.4881 15.75 20.4881C20.0741 20.4881 23.5833 16.9 23.5833 12.5C23.5833 8.10005 20.0741 4.5119 15.75 4.5119C11.6294 4.5119 8.25574 7.77202 7.94654 11.886L7.92634 12.1548H8.19583H11.1708L5.83333 19.3712L0.495856 12.1548H3.52917Z"
          fill="#231F20"
          stroke="#FBFBFB"
          style={{
            fill: "#231F20",
            fill: "color(display-p3 0.1373 0.1216 0.1255)",
            fillOpacity: 1,
            stroke: "#FBFBFB",
            stroke: "color(display-p3 0.9830 0.9830 0.9830)",
            strokeOpacity: 1,
          }}
          strokeWidth="0.5"
        />
      </svg>
    </>
  );
};
